import React, { useState, useEffect } from "react";
import { apiGet, apiPost } from "api/callApi";
import { Button, Loader } from "InnoUI/components";
import InnoIcons from "InnoUI/innoicons";
import ProjectSection from "./ProjectSection";
import theme from "theme";
import SC from "./style";
import { showAlert } from "utils/helper";
import ct from "countries-and-timezones";

const LinkProjects = (props) => {
  const {
    onClose,
    projectData,
    fetchData = () => {},
    setSelectedItem = () => {},
    setOpenDrwer = () => {},
  } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const getAllData = async () => {
    try {
      setLoading(true);
      // const response = await apiGet(
      //   `/v1/projects/getholiday/${projectData.id}`
      // );
      const response = await apiGet(
        `/v1/getholiday/${1}?country=${projectData?.countryName}`
      );
      setData(response.data);
      setLoading(false);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllData();
  }, []);

  const getLinkedIds = async () => {
    try {
      const response = await apiGet(
        `/v1/projects/getholiday/${projectData.id}`
      );

      setSelectedItems(response.data);
    } catch (error) {
      console.error("Error fetching linked project IDs:", error);
    }
  };

  useEffect(() => {
    if (projectData?.id && !Array.isArray(projectData.id)) {
      getLinkedIds();
    }
  }, [projectData?.id]);

  const linkProject = async () => {
    const projectIds = Array.isArray(projectData?.id)
      ? projectData.id
      : [projectData?.id];


    try {
      const response = await apiPost(`/v1/holiday/linkholidaytoproject`, {
        holidayIds: selectedItems,
        projectIds: projectIds,
        isProject: true,
      });

      showAlert({ title: "Success", text: response?.message, icon: "success" });

      await fetchData();
      setSelectedItem([]);
      setOpenDrwer(false);
    } catch (error) {
      console.error("Linking error:", error);
    }
  };

  const onSelectionChange = (id, selectAll = false) => {
    if (id === "clear") {
      setSelectedItems([]);
      return;
    }

    const availableRoleIds = data.map((item) => item.id);

    setSelectedItems((prevSelectedItems) => {
      if (selectAll) {
        return availableRoleIds;
      }

      const isValidRole = availableRoleIds.includes(id);
      if (!isValidRole) {
        console.warn("Invalid Role ID:", id);
        return prevSelectedItems;
      }

      const updatedSelectedItems = prevSelectedItems.includes(id)
        ? prevSelectedItems.filter((item) => item !== id)
        : [...prevSelectedItems, id];

      return updatedSelectedItems.filter((item) =>
        availableRoleIds.includes(item)
      );
    });
  };

  const country = ct.getCountry(projectData.countryName);

  return (
    <>
      <SC.DrawerTitlesContainer>
        <SC.DrawerTitles>
          {projectData?.propertyName || "holiday"} - Builder Holidays in{" "}
          {country.name} Region
        </SC.DrawerTitles>
        <SC.CloseIcon>
          <InnoIcons.CloseIcon onClick={onClose} />
        </SC.CloseIcon>
      </SC.DrawerTitlesContainer>

      {loading && <Loader />}

      <div style={{ padding: "20px 20px" }}>
        <ProjectSection
          items={data}
          // items={
          //   filterLinkProject
          //     ? data.filter((item) => selectedItems.includes(item.id))
          //     : data
          // }
          title="Builder Holiday"
          onSelectionChange={onSelectionChange}
          selectedItems={selectedItems}
        />
      </div>

      <SC.ButtonContainer>
        <Button
          caption="Cancel"
          fontSize="12px"
          style={{
            marginBottom: 8,
            background: "#f7f9f7",
            color: theme.colors.white,
            minWidth: "100px",
            borderRadius: "3px",
            height: "30px",
            fontSize: "12px",
          }}
          onClick={onClose}
        />
        <Button
          caption={"Save"}
          type="submit"
          isLoading={loading}
          onClick={linkProject}
          color="white"
          fontSize="12px"
          style={{
            marginBottom: 8,
            background: theme.gradient.themeGradient,
            color: theme.colors.white,
            minWidth: "100px",
            height: "30px",
            borderRadius: "3px",
          }}
          disabled={data.length == 0}
        />
      </SC.ButtonContainer>
    </>
  );
};

export default LinkProjects;
